import queryString from 'query-string';

import {
    requestFacetedItems,
    setSelectedFacet,
    clearCustomPriceRange,
    showMobileFacetPanel,
    hideMobileFacetPanels,
    hideMobileFacets
 } from '../actions/facetActions';

import {
    getCurrentCategory,
    getQSWithoutFacetType,
    updateScrollPositionForFacets,
    getLastFacetItemByFilterType
} from '../utils/utils';

import { submitCustomPriceForm } from '../sagas/categoryFacetSagas';

import template from 'facets/category-facet-types-mobile.j2';
import { dDom } from '../../../core/js/utils/renderUtils';
import { generate } from '../../../core/js/utils/componentUtils';
import { getDefaultOptions } from '../../../core/js/utils/a15componentUtils';
import { DONE_BUTTON_CLICKED } from '../utils/mobileFacetUtils';
import { CATEGORY_REFINEMENT_NAMES } from '@core/js/constants';

import { init as initCustomPriceRangeComponent } from './customPriceRangeComponent';

function deactivateSelectedFacets(el) {}

/**
 * Attach component events to DOM
 * @param {object} store - The store
 * @param {number} componentIndex - Sets data index
 * @returns {undefined}
 */
export function attachEvents(store, componentIndex) {
    $(document).on('click', this.scopedSelector('.js-facet'), (e) => {
        e.stopPropagation();
        $(e.target).find('.js-facet__a')
                   .trigger('click');
    });

    $(document).on('click', this.scopedSelector('.js-facet__a'), (e) => {
        e.preventDefault();
        this.attachLoader(store, { location: this.componentLocation });
        const el = $(e.currentTarget);
        const categoryId = getCurrentCategory();
        const facetName = el.closest('[data-facet-name]').data('facet-name');
        const facetValue = el.closest('[data-facet-value]').data('facet-value');
        const isSelected = el.is(':checked');
        const qs = el.attr('data-query-string');
        const state = store.getState();
        const selectedFacetType = _.get(state, 'category.selectedFacetType', null);

        store.dispatch(setSelectedFacet(facetName, selectedFacetType));
        store.dispatch(requestFacetedItems(categoryId, facetName, facetValue, isSelected, qs, true, e, this));
    });

    $(document).on(this.scopedEvent('touchend click'), `div[data-index=${componentIndex}] .js-mobile-filter-back`,
    (e) => {
        e.preventDefault();
        store.dispatch(setSelectedFacet());
        store.dispatch(hideMobileFacetPanels());
    });

    $(document).on(this.scopedEvent('touchend click'), this.scopedSelector('.js-mobile-filter-close'),
    (e) => {
        e.preventDefault();

        // if we are closing the price mobile menu
        if($(e.target).hasClass('js-price-button')) {
            const state = store.getState();
            const nav = _.get(state, 'category.facetOptions.nav');
            const priceFacet = _.find(nav, { 'name': CATEGORY_REFINEMENT_NAMES.PRICE });

            // and a user has set a custom price filter, request items with those ranges applied
            if(_.get(priceFacet, 'customPriceRange.min') || _.get(priceFacet, 'customPriceRange.max')) {
                this.attachLoader(store);
                store.dispatch(setSelectedFacet('price'));
                store.runSaga(submitCustomPriceForm, store, e, this, DONE_BUTTON_CLICKED);
                return false;
            }
        }

        this.closeModalFacets();
        return false;
    });

    $(document).on(this.scopedEvent('touchend click'), `div[data-index=${componentIndex}] .js-mobile-filter-clear`,
    (e) => {
        e.preventDefault();

        if($(e.target).hasClass('js-price-button')) {
            store.dispatch(clearCustomPriceRange());
        }

        const el = $(e.currentTarget);
        const qs = el.attr('data-applied-facets-query');
        const facetTypeValue = el.attr('data-facet-type')
                                 .trim()
                                 .toLowerCase();

        this.attachLoader(store, { location: this.componentLocation });
        const qsWithoutFacetType = getQSWithoutFacetType(qs, facetTypeValue);

        store.dispatch(requestFacetedItems(getCurrentCategory(), '', '', false,
                       queryString.stringify(qsWithoutFacetType)));
        deactivateSelectedFacets(el);
    });

    $(document).on(this.scopedEvent('click'), `div[data-index=${componentIndex}] .js-facets-see-all`, (e) => {
        e.preventDefault();
        const state = this.getState();

        this.attachLoader(store);
        this.lastFacetItemByFilterType = getLastFacetItemByFilterType(this);
        const facetName = $(e.target).data('facet-name');
        const categoryId = state.category.categorySlug;
        const qs = $(e.target).attr('data-query-string');
        const selectedFacetType = _.get(state, 'category.selectedFacetType', null);

        store.dispatch(setSelectedFacet(facetName, selectedFacetType, true));
        store.dispatch(requestFacetedItems(categoryId, facetName, '', '', qs, true, e, this));
    });

    $(document).on(this.scopedEvent('click'), '.js-facet-panel', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if ($(e.target).hasClass('js-mobile-filter-clear')) {
            return false;
        }
        const selectedFacetType = $(e.currentTarget).find('.js-facets__h4')
                                                   .attr('data-facet-type');
        $('.js-modal-facets').hide();
        store.dispatch(setSelectedFacet(null, selectedFacetType));
        store.dispatch(showMobileFacetPanel(selectedFacetType));
        return false;
    });
}

function closeModalPanel() {
    this.dispatch(setSelectedFacet());
    this.dispatch(hideMobileFacetPanels());
}

function closeModalFacets() {
    this.closeModalPanel();
    this.dispatch(hideMobileFacets());
}

export function afterRender(store) {
    this.removeLoader(store);
    const state = store.getState();
    const componentIndex = _.findIndex(state.category.products.availableNavigation,
        (navItem) => (navItem.name === state.category.selectedFacet));

    if (this.multipleIndex === componentIndex) {
        updateScrollPositionForFacets(this);
    }
}

export function generateDictionary(state, dictionary, config) {
    const dict = {
        navItem: state.category.facetOptions.nav[config.multipleIndex],
        facetIndex: config.multipleIndex,
        selectedFacetType: state.category.mobileFacetState.selectedFacetType
    };

    return Object.assign({}, state, dictionary, dict);
}

/**
 * Bootstrap the component onto the page
 * @param {object} store - The store
 * @param {object} overrides - The overrides object
 * @returns {undefined}
 */
export function init(store, overrides = {}) {
    const config = {
        children: [
            initCustomPriceRangeComponent
        ],
        templateLocation: '.dom-facet-modal-panel',
        watch: ['category.queryString', 'category.mobileFacetState'],
        name: 'mobileFacetTypeComponent',
        bodyClass: 'has-modal-open',
        attachEvents: attachEvents,
        template: template,
        generateDictionary: generateDictionary,
        renderType: dDom,
        afterRender: afterRender,
        lastFacetItemByFilterType: {},
        closeModalPanel: closeModalPanel,
        closeModalFacets: closeModalFacets
    };
    const navItems = _.get(store.getState(), 'category.facetOptions.nav', {});
    config.multiple = (reduxStore) => navItems.length;
    return generate(config, store, overrides, getDefaultOptions(store));
}
